<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <g>
      <path d="M12.62,22.5c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88,1.29-2.88,2.88-2.88,2.88,1.29,2.88,2.88Z" fill="currentcolor"/>
      <path d="M9.73,26.88c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM9.73,21.12c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    </g>
    <g>
      <path d="M25.38,22.5c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88c0-1.59,1.29-2.88,2.88-2.88s2.88,1.29,2.88,2.88Z" fill="currentcolor"/>
      <path d="M22.5,26.88c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM22.5,21.12c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    </g>
    <g>
      <path d="M38.15,22.5c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88,1.29-2.88,2.88-2.88,2.88,1.29,2.88,2.88Z" fill="currentcolor"/>
      <path d="M35.27,26.88c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM35.27,21.12c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    </g>
  </svg>
</template>

<style scoped lang="scss">

</style>